import React, { useEffect, useRef, useState } from 'react';
import { MotifIcon } from '@ey-xd/motif-react';
import {
  navigationIcArrowDropDown24px,
  navigationIcArrowDropUp24px,
} from '@ey-xd/motif-react/assets/icons';
import sortIcon from '@assets/icons/table-sort.svg';
import activeFilter from '@assets/icons/activeFilter.svg';
import inactiveFilter from '@assets/icons/inactiveFilter.svg';
import '@molecules/gcsp/styles/tableHeaderStyle.css';

const TableHeader = props => {
  const [ascSort, setAscSort] = useState('inactive');
  const [descSort, setDescSort] = useState('inactive');
  const [noSort, setNoSort] = useState('inactive');
  const [isFilterActive, setIsFilterActive] = useState(false);
  const refButton = useRef(null);

  const onMenuClicked = () => {
    props.showFilter(refButton?.current);
  };

  const onSortChanged = () => {
    setAscSort(props.column.isSortAscending() ? 'active' : 'inactive');
    setDescSort(props.column.isSortDescending() ? 'active' : 'inactive');
    setNoSort(
      !props.column.isSortAscending() && !props.column.isSortDescending() ? 'active' : 'inactive',
    );
  };

  const onSortRequested = (order, event) => {
    props.setSort(order, event.shiftKey);
  };

  const onFilterChanged = () => {
    setIsFilterActive(props.column.isFilterActive());
  };

  useEffect(() => {
    props.column.addEventListener('sortChanged', onSortChanged);
    props.column.addEventListener('filterChanged', onFilterChanged);
    onSortChanged();
    onFilterChanged();
    return () => {
      props.column.removeEventListener('sortChanged', onSortChanged);
      props.column.removeEventListener('filterChanged', onFilterChanged);
    };
  }, []);

  let menu = null;
  if (props.enableMenu) {
    menu = (
      <div
        ref={refButton}
        className="customHeaderMenuButton"
        onClick={() => onMenuClicked()}
        role="button"
        tabIndex="0"
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            onMenuClicked();
          }
        }}
      >
        {isFilterActive ? <img src={activeFilter} alt=" " /> : <img src={inactiveFilter} alt=" " />}
      </div>
    );
  }

  let sort = null;

  // function to change the sort icon once it has been clicked.
  const showSortIcon = () => {
    if (noSort === 'inactive' && ascSort === 'inactive' && descSort === 'inactive') {
      sort = (
        <div style={{ display: 'inline-block' }}>
          <div
            onClick={event => onSortRequested('asc', event)}
            onTouchEnd={event => onSortRequested('asc', event)}
            className={`customSortDownLabel ${ascSort}`}
            role="button"
            tabIndex="0"
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                onSortRequested('asc', e);
              }
            }}
          >
            <MotifIcon src={navigationIcArrowDropUp24px} />
            <MotifIcon src={navigationIcArrowDropDown24px} />
          </div>
        </div>
      );
    } else if (noSort === 'active' && ascSort === 'inactive' && descSort === 'inactive') {
      sort = (
        <div style={{ display: 'inline-block' }}>
          <div
            onClick={event => onSortRequested('asc', event)}
            onTouchEnd={event => onSortRequested('asc', event)}
            className={`customSortDownLabel ${ascSort}`}
            style={{ margin: '-4px 0' }}
            role="button"
            tabIndex="0"
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                onSortRequested('asc', e);
              }
            }}
          >
            <img src={sortIcon} alt="Sort" />
          </div>
        </div>
      );
    } else if (noSort === 'inactive' && ascSort === 'active' && descSort === 'inactive') {
      sort = (
        <div style={{ display: 'inline-block' }}>
          <div
            onClick={event => onSortRequested('desc', event)}
            onTouchEnd={event => onSortRequested('desc', event)}
            className={`customSortUpLabel ${descSort}`}
            role="button"
            tabIndex="0"
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                onSortRequested('desc', e);
              }
            }}
          >
            <MotifIcon src={navigationIcArrowDropUp24px} />
          </div>
        </div>
      );
    } else if (noSort === 'inactive' && ascSort === 'inactive' && descSort === 'active') {
      sort = (
        <div style={{ display: 'inline-block' }}>
          <div
            onClick={event => onSortRequested('', event)}
            onTouchEnd={event => onSortRequested('', event)}
            className={`customSortRemoveLabel ${noSort}`}
            role="button"
            tabIndex="0"
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                onSortRequested('', e);
              }
            }}
          >
            <MotifIcon src={navigationIcArrowDropDown24px} />
          </div>
        </div>
      );
    }
  };

  //set sort variable only if enableSorting is set to true in headerComponentParams{}
  if (props.enableSorting) {
    showSortIcon();
  }

  let title = null;
  // 2 cases are possible 1: Title and subText both exist 2: only Title exists
  if (props.subText !== undefined) {
    title = (
      <div className="titleContainer">
        <div
          className="customHeaderTitle"
          style={{
            overflow: 'hidden',
            color: '#1A1A24)',
            textOverflow: 'ellipsis',
            fontFamily: 'EYInterstate',
            fontSize: '14px',
            fontWeight: '400',
          }}
        >
          {props.displayName}
        </div>
        <div
          className="customHeaderSubText"
          style={{
            overflow: 'hidden',
            color: '#000',
            textOverflow: 'ellipsis',
            fontFamily: 'EYInterstate',
            fontSize: '10px',
            fontWeight: '300',
          }}
        >
          {props.subText}
        </div>
        <div
          className="customHeaderSubText"
          style={{
            overflow: 'hidden',
            color: '#000',
            textOverflow: 'ellipsis',
            fontFamily: 'EYInterstate',
            fontSize: '10px',
            fontWeight: '300',
          }}
        >
          {props.subText2}
        </div>
      </div>
    );
  } else {
    title = (
      <div className="titleContainerNoSubtext">
        <div
          className="customHeaderTitle"
          style={{
            overflow: 'hidden',
            color: '#1A1A24)',
            textOverflow: 'ellipsis',
            fontFamily: 'EYInterstate',
            fontSize: '14px',
            fontWeight: '400',
          }}
        >
          {props.displayName}
        </div>
      </div>
    );
  }

  return (
    <div className="headerContainer">
      {title}
      {sort}
      {menu} {/*this is for filter button */}
    </div>
  );
};

export default TableHeader;
